import RelatorioChamadas from '../_views/RelatorioChamadas'

import { permissoesRelatoriosChamadas } from '../../../utils/permissionsRelatoriosPabx'

export default [
  {
    path: 'chamadas',
    component: RelatorioChamadas,
    meta: { requiresAuth: true, permissions: [...permissoesRelatoriosChamadas] },
    name: 'relatorios_pabx_chamadas',
  },
]
